<template>
    <div>
        <div v-if="$route.name === 'ProjectDetail'" class="project-detail">
            <div class="project-detail-header">
                <p>{{ header.title }}</p>
                <span> 发布时间： </span>
                <span> 阅读次数： </span>
            </div>
            <div class="project-detail-info">
                <div class="project-detail-info-mark" />
                <div class="project-detail-info-item">
                    <span class="data-label">当前状态</span>
                    <span style="color: #5bffd9">{{ header.statusText }}</span>
                </div>
                <div class="project-detail-info-item">
                    <span class="data-label">标段/包编号</span>
                    <span>{{ header.bdBH }}</span>
                </div>
                <div class="project-detail-info-item">
                    <span class="data-label">采购方式</span>
                    <span>{{ header.type }}</span>
                </div>
                <div class="project-detail-info-item">
                    <span class="data-label">项目类型</span>
                    <span>{{ header.projectType }}</span>
                </div>
                <div class="project-detail-info-item">
                    <span class="data-label">招标人</span>
                    <span>{{ header.creator }}</span>
                </div>
                <div class="project-detail-info-item">
                    <span class="data-label">项目名称</span>
                    <span>{{ header.gcName }}</span>
                </div>
                <div class="project-detail-info-item">
                    <span class="data-label">项目编号</span>
                    <span>{{ header.code }}</span>
                </div>
            </div>
            <zl-card-title title="进度详情">
                <div class="zl-progress-wrapper">
                    <zl-progress
                        v-for="item in nodes"
                        :key="item.value"
                        :title="item.label"
                        :value="item.value"
                        :status="header.status"
                        :actions="item.actions"
                        :fields="item.fields"
                        :date="item.date"
                        @handleClick="handleActionClick"
                    />
                </div>
            </zl-card-title>
        </div>
        <router-view />
    </div>
</template>

<script>
    import ZlProgress from '@/components/ZlProgress'
    import ZlCardTitle from '@/components/ZlCardTitle'
    const {
        nodes,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/projectStatusType`)
    const { mixin } = require(`@/config/${process.env.VUE_APP_PROJECT}/projectDetail`)
    export default {
        name: 'ProjectDetail',
        components: {
            ZlProgress,
            ZlCardTitle,
        },
        mixins: [mixin],
        data() {
            return {
                header: {
                    title: '', // 标题
                    status: 0, // 状态编号
                    statusText: '', // 状态名称
                    code: '', // 项目编号
                    type: '', // 招标类型
                    projectType: '', // 项目类型
                    creator: '', // 创建人
                },
                nodes: JSON.parse(JSON.stringify(nodes)),
            }
        },
        created() {
            this.getData()
        },
        methods: {
            handleActionClick(item) {
                if (item.value.indexOf('url:') > -1) {
                    this.$router.push({
                        path: item.value.split(':')[1],
                        query: {
                            id: this.$route.query.id,
                        },
                    })
                } else {
                    this.$router.push({
                        name: 'ProjectSubDetail',
                        query: {
                            title: item.label,
                            type: item.value,
                            id: this.$route.query.id,
                            ggBDGuid: this.header.ggBDGuid,
                        },
                    })
                }
            },
        },
    }
</script>

<style lang="scss">
@import "../../assets/style/projectDetail.scss";
.project-detail {
  .zl-progress-wrapper {
    padding-left: 16px;
    padding-top: 24px;
  }
}
</style>
